import { ofType, combineEpics } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";
import { getAuthToken } from "@/util/session";
import { getPaymentId, getPartialRefundItems } from "../Payment.selectors";
import {
  REQUEST_PAYMENT_MODIFICATION,
  paymentModificationPreAuthFailed,
  paymentModificationPreAuthStarted,
  paymentModificationPreAuthSucceeded,
  requestRefundPayment,
  requestVoidPayment,
  SUBMIT_VOID_REFUND_MODAL,
  PAYMENT_MODIFICATION_TYPES,
} from "../Payment.state";

const submitVoidRefundEpic = (action$, _state$) =>
  action$.pipe(
    ofType(SUBMIT_VOID_REFUND_MODAL),
    RxOp.flatMap(({ payload: { paymentType } }) =>
      paymentType === PAYMENT_MODIFICATION_TYPES.REFUND
        ? Rx.of(
            requestRefundPayment({
              accessToken: S.fromMaybe("")(getAuthToken()),
            })
          )
        : Rx.of(
            requestVoidPayment({
              accessToken: S.fromMaybe("")(getAuthToken()),
            })
          )
    )
  );

const modificationPreAuthEpic = (action$, state$) =>
  action$.pipe(
    ofType(REQUEST_PAYMENT_MODIFICATION),
    RxOp.mergeMap(({ payload: { accessToken, modificationType } }) => {
      const paymentId = getPaymentId(state$.value);
      const partialRefundItems = getPartialRefundItems(state$.value);
      return S.isNothing(paymentId)
        ? Rx.of(
            paymentModificationPreAuthFailed({
              error: Error("no payment selected"),
            })
          )
        : Rx.of(
            paymentModificationPreAuthStarted(),
            paymentModificationPreAuthSucceeded({
              token: accessToken,
              paymentId: paymentId.value,
              partialRefundItems: partialRefundItems,
              modificationType,
            })
          );
    }),
    RxOp.catchError((err) =>
      Rx.of(paymentModificationPreAuthFailed({ error: err.message }))
    )
  );

export default combineEpics(modificationPreAuthEpic, submitVoidRefundEpic);
